<div class="kr-wallet-card-empty" [class.kr-wallet-card-empty_large]="large()">
  <img
    class="kr-wallet-card-empty__img"
    src="assets/images/wallet-card.png"
    alt="Wallet card" />
</div>
